import { render, staticRenderFns } from "./SoonVuePage.vue?vue&type=template&id=950808f4"
import script from "./SoonVuePage.vue?vue&type=script&lang=js"
export * from "./SoonVuePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('950808f4')) {
      api.createRecord('950808f4', component.options)
    } else {
      api.reload('950808f4', component.options)
    }
    module.hot.accept("./SoonVuePage.vue?vue&type=template&id=950808f4", function () {
      api.rerender('950808f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SoonVuePage.vue"
export default component.exports